import { zeroAddress } from 'viem'
import type { ChainConfig } from '../..'

export const BERACHAIN = {
  name: 'berachain',
  explorerUrl: 'https://berascan.com/',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'BERA',
    symbol: 'BERA',
  },
  slip44: 60,
  wrappedNativeAsset: '0x6969696969696969696969696969696969696969',
  blockscoutApiUrl: undefined,
  etherscanApiUrl: 'https://api.berascan.com/api',
  publicRpcUrls: ['https://berachain-mainnet.g.alchemy.com/public', 'https://rpc.berachain.com'],
  getPrivateRpcUrls: () => {
    const berachain: string[] = []
    process.env.ALCHEMY_API_KEY &&
      berachain.push(`https://berachain-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return berachain
  },
} as const satisfies ChainConfig
